import { Button, type ButtonProps } from "@octopus-energy/coral/atoms"
import { useActionsContext } from "../../../contexts/actions-context"

export function ActionsCancel({ children, disabled, ...props }: ButtonProps) {
    const { loading, step } = useActionsContext()

    return (
        <Button
            disabled={disabled || loading}
            variant="text"
            color="base100"
            attributes={{ "data-testid": step ? "backButton" : "cancelButton" }}
            {...props}
        >
            {children ?? (step ? "Retour" : "Annuler")}
        </Button>
    )
}
